/* @flow */
import React, {Component} from 'react';
import {action, autorun, observable} from 'mobx';
import {inject, observer} from 'mobx-react';
import CSSTransition from '../CSSTransition';
import './toast.scss';

type Props = {
    show: boolean,
    onRequestClose: Function,
    duration: number,
    message: string,
    style: ?Object,
    className: ?string,
    containerStyle: ?Object,
    containerClassName: ?string,
    appStore: Object
}

@inject('appStore')
@observer
class Toast extends Component<Props> {
    @observable showToast = this.props.appStore.toastData.show;
    @observable timer = undefined;
    listener = () => {};

    componentDidMount() {
        this.listener = autorun(() => {
            this.toast(this.props.appStore.toastData.show);
        });
    }

    componentWillUnmount() {
        this.listener();
    }

    @action toast(show: boolean) {
        if (show) {
            clearTimeout(this.timer);
            this.showToast = true;
            this.timer = setTimeout(() => this.hideToast(), this.props.appStore.toastData.duration);
        } else {
            this.hideToast();
        }
    }

    @action hideToast() {
        this.showToast = false;
        this.props.appStore.dismissToast();
    }

    render() {
        const {toastData} = this.props.appStore;
        const {message, className, style, containerClassName, containerStyle, animation} = toastData;
        return <CSSTransition
            animation={animation || 'fade'}
            className={`toast-container ${containerClassName || ''}`}
            style={containerStyle}>
            {this.showToast &&
            <div key={1} className={`toast ${className || ''}`} style={style}>
                <div className="toast-message text-center">{message}</div>
            </div>}
        </CSSTransition>;
    }
}

export default Toast;
